"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _DropAreaBase = _interopRequireDefault(require("../DropAreaBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles(theme) {
  return {
    root: {
      position: 'relative'
    },
    dragOver: {
      '& *': {
        pointerEvents: 'none'
      },
      '& $overlay': {
        pointerEvents: 'default'
      }
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
      pointerEvents: 'none',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: 0,
      background: (0, _colorManipulator.fade)(theme.palette.background.default, 0.5),
      transition: 'opacity .3s ease'
    },
    overlayDragging: {
      opacity: 1,
      '& $iconContainer': {
        animation: 'wui-invisibledroparea-pulse 1s infinite'
      }
    },
    iconContainer: {
      background: theme.palette.primary.main,
      borderRadius: '50%',
      marginBottom: theme.spacing.unit * 3,
      width: 96,
      height: 96,
      padding: 16,
      boxSizing: 'content-box'
    },
    icon: {
      color: theme.palette.getContrastText(theme.palette.primary.main),
      width: 96,
      height: 96
    },
    disabled: {},
    '@keyframes wui-invisibledroparea-pulse': {
      '0%': {
        boxShadow: "0 0 0 0 ".concat(theme.palette.primary.main)
      },
      '50%': {
        boxShadow: "0 0 0 5px ".concat(theme.palette.primary.main)
      },
      '100%': {
        boxShadow: "0 0 0 0 ".concat(theme.palette.primary.main)
      }
    }
  };
};

var InvisibleDropArea = _react.default.forwardRef(function InvisibleDropArea(props, ref) {
  var _classNames;

  var activeIcon = props.activeIcon,
      activeText = props.activeText,
      children = props.children,
      className = props.className,
      classes = props.classes,
      onSelectFiles = props.onSelectFiles,
      other = _objectWithoutProperties(props, ["activeIcon", "activeText", "children", "className", "classes", "onSelectFiles"]);

  var _React$useState = _react.default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      dragOver = _React$useState2[0],
      setDragOver = _React$useState2[1];

  var handleDragOver = function handleDragOver() {
    setDragOver(true);
  };

  var handleDragLeave = function handleDragLeave(e) {
    if (e.target === e.currentTarget) {
      setDragOver(false);
    }
  };

  var handleSelectFiles = function handleSelectFiles(files) {
    setDragOver(false);
    onSelectFiles(files);
  };

  return _react.default.createElement(_DropAreaBase.default, _extends({}, other, {
    className: (0, _classnames.default)(classes.root, className, (_classNames = {}, _defineProperty(_classNames, classes.disabled, props.disabled), _defineProperty(_classNames, classes.dragOver, dragOver), _classNames)),
    onAcceptedDragEnter: handleDragOver,
    onDragLeave: handleDragLeave,
    onSelectFiles: handleSelectFiles,
    ref: ref
  }), children, _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.overlay, _defineProperty({}, classes.overlayDragging, dragOver))
  }, activeIcon && _react.default.createElement("div", {
    className: classes.iconContainer
  }, _react.default.cloneElement(activeIcon, {
    className: classes.icon
  })), activeText && _react.default.createElement(_Typography.default, null, activeText)));
});

InvisibleDropArea.propTypes = {
  /**
   * Icon to display when an accepted file is dragged over the area.
   */
  activeIcon: _propTypes.default.node,

  /**
   * Text to display when an accepted file is dragged over the area.
   */
  activeText: _propTypes.default.string,

  /**
   * Used to render content in the drop area.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Callback fired when the user drops one or more accepted files.
   */
  onSelectFiles: _propTypes.default.func.isRequired
};

var _default = (0, _styles.withStyles)(styles)(InvisibleDropArea);

exports.default = _default;